


import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  AppBar,
  Chip,
  Button,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import StatusChip from "./StatusChip";
import InputAdornment from "@mui/material/InputAdornment";



/**
 * Reusable filter bar component
 * @param {Object} filters - Current filter values
 * @param {function} onFilterChange - Callback when filters change
 * @param {Array} warehouseOptions - Options for warehouse dropdown
 * @param {Array} statusTypes - Options for status dropdown
 * @param {boolean} disableStatusField - Whether to disable status field
 * @param {Array} extraFields - Additional text fields to include
 * @param {Object} customStyles - Optional custom styles
 */
function MultipleSearchFilterMyAction({
  filters,
  onFilterChange,
  warehouseOptions = [],
  statusTypes = [],
  disableStatusField = false,
  extraFields = [],
  searchFields = [],
  actionTypeOptions = [],
  customStyles = {}
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const DOC_TYPE_OPTIONS = actionTypeOptions.length > 0
    ? actionTypeOptions
    : [
        { value: "GRN", label: "GRN" },
        { value: "Return", label: "Return" },
      ];

const handleChange = (field, value) => {
  const updated = {
    ...filters,
    [field]: value,
  };

  // 👇 Clear searchValue when searchType changes
  if (field === "searchType") {
    updated.searchValue = "";
  }

  onFilterChange(updated);
};

  const handleStatusChange = (value) => {
    const updated = { ...filters, status: value };
    onFilterChange(updated);
  };

  const handleClearFilters = () => {
    const clearedFilters = { ...filters };
    Object.keys(clearedFilters).forEach(key => {
      if (key.includes('Date')) {
        clearedFilters[key] = null;
      } else {
        clearedFilters[key] = "";
      }
    });
    onFilterChange(clearedFilters);
  };

  

  const renderStatusValue = (selected) => {
    if (!selected) return <Chip label="All" size="small" />;
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <StatusChip
          statusCode={selected}
          statusTypes={statusTypes}
          customStyles={{ fontWeight: 500 }}
        />
      </Box>
    );
  };

  const renderStatusMenuItem = (item, isAll = false) => {
    if (isAll) {
      return (
        <MenuItem value="">
          <Chip label="All" size="small" />
        </MenuItem>
      );
    }

    return (
      <MenuItem key={item.grnstatuscode || item.trsts} value={item.grnstatuscode || item.trsts}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <StatusChip
            statusCode={item.grnstatuscode || item.trsts}
            statusTypes={[item]}
            customStyles={{ fontWeight: 400 }}
          />
        </Box>
      </MenuItem>
    );
  };

  return (
    <AppBar sx={{ ...styles.vg_search_appbar, ...customStyles.appBar }}>
      <Grid container spacing={2} sx={styles.appbar_grid_container}>
 <Grid
  item
  size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
  sx={styles.appbar_grid_search}
>
  <TextField
    fullWidth
    size="small"
    label="Search"
    value={filters.searchValue || ""}
    onChange={(e) => handleChange("searchValue", e.target.value)}
  />
</Grid>

        <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
        <FormControl variant="outlined" fullWidth size="small">
    <InputLabel>Type</InputLabel>
    <Select
      value={filters.actionType || ""}
      onChange={(e) => handleChange("actionType", e.target.value)}
      label="Type"
      MenuProps={{ PaperProps: { sx: { boxShadow: 2 } } }}
    >
      <MenuItem value="">
        <Chip label="All" size="small" />
      </MenuItem>
      {DOC_TYPE_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
        </Grid>

        <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
          <FormControl variant="outlined" fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status || ""}
              onChange={(e) => handleStatusChange(e.target.value)}
              label="Status"
              disabled={disableStatusField}
              renderValue={renderStatusValue}
              MenuProps={{
                PaperProps: {
                  sx: { boxShadow: 2 },
                },
              }}
            >
              {renderStatusMenuItem(null, true)}
              {statusTypes.map((item) => renderStatusMenuItem(item))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From Date"
              value={filters.fromDate || null}
              format="DD/MM/YYYY"
              onChange={(value) => handleChange("fromDate", value)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              value={filters.toDate || null}
              format="DD/MM/YYYY"
              onChange={(value) => handleChange("toDate", value)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid
          item
          size={{ xs: 12, sm: 6, md: 1, lg: 1, xl: 1 }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="text"
            size="medium"
            startIcon={<ClearOutlinedIcon />}
            sx={{ ...styles.btn_text, color: theme.palette.text.secondary }}
            onClick={handleClearFilters}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </AppBar>
  );
}

export default MultipleSearchFilterMyAction;
